import {FeatureId} from "./FeatureId";

export const FeaturesMaxDisplayCountMap: Record<FeatureId, number> = {
    [FeatureId.OnboardingTour] : 1
}